import {
    ProductChargingMode,
    ProductConsumptionMoment,
    ProductPostingMode,
    ServiceType,
} from '@mews-commander/data-access';
import { ContentSection, DividerList, LabeledListItem } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { Optional } from '@mews/std';
import { useCurrentService } from '../../../queries/useCurrentService';
import { LocalizedChargingMode } from '../../localization/LocalizedChargingMode';

interface Props {
    charging: ProductChargingMode | ProductPostingMode;
    consumptionMoment: Optional<ProductConsumptionMoment>;
}
export const ChargingSection = ({ charging, consumptionMoment }: Props) => {
    const { data } = useCurrentService();

    return (
        <ContentSection title={lt('Charging')}>
            <DividerList>
                {data.discriminator === ServiceType.Bookable ? (
                    <LabeledListItem label={lt('Frequency')}>
                        <Tag variant="basicSubtle" outline>
                            <LocalizedChargingMode charging={charging} bookableServiceData={data.value} />
                        </Tag>
                    </LabeledListItem>
                ) : null}

                {data.discriminator === ServiceType.Bookable ? (
                    <LabeledListItem label={lt('Timing')}>
                        {consumptionMoment ? (
                            <Tag variant="basicSubtle" outline>
                                {lt(`ProductConsumptionMoment${consumptionMoment}`)}
                            </Tag>
                        ) : (
                            UnicodeEntity.Dash
                        )}
                    </LabeledListItem>
                ) : null}
            </DividerList>
        </ContentSection>
    );
};
